"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'articlePublic',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {
        article_type: this.$route.query.type || 1,
        start: 1,
        total: 10,
        page_num: 1
      },
      info: {},
      detailVisible: false
    };
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.listQuery.article_type = tab.name;
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/article/public_list';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 文章详情
     */
    getDetail: function getDetail(row) {
      var _this2 = this;
      this.$get('agentapi/article/detail', {
        id: row.id
      }).then(function (res) {
        _this2.info = res.info;
        _this2.detailVisible = true;
      });
    }
  }
};